import React from 'react';

import PropTypes from 'prop-types';

import Extract from '@/images/icons/extract.png';
import CalendarIcon from '@/svg-icons/calendar-menu';
import MenuDivergences from '@/svg-icons/divergences-menu';
import FinishedOrders from '@/svg-icons/finished-orders';
import InspectorsIcon from '@/svg-icons/inspector';
import SubMenuAtivos from '@/svg-icons/menu-ativos';
import MenuClientes from '@/svg-icons/menu-clientes';
import MenuDashboard from '@/svg-icons/menu-dashboard';
import MenuDispositivos from '@/svg-icons/menu-dispositivos';
import SubMenuRemovidos from '@/svg-icons/menu-removidos';
import SettingsIcon from '@/svg-icons/menu-settings';
import MenuVistorias from '@/svg-icons/menu-vistorias';
import SectionArquivadas from '@/svg-icons/section-arquivadas';
import SectionCanceladas from '@/svg-icons/section-canceladas';
import SectionEnviadas from '@/svg-icons/section-enviadas';
import SectionIndependentes from '@/svg-icons/section-independentes';
import SectionPrincipal from '@/svg-icons/section-principal';
import SectionRecusadas from '@/svg-icons/section-recusadas';
import TypeNone from '@/svg-icons/type-none';

const buildIconStyle = (fontSize, marginRight = '16px') => ({
  marginRight,
  fontSize,
  width: '1em',
  height: '1em',
  display: 'inline-block',
  flexShrink: 0,
});

const menuIcons = {
  active: <SectionPrincipal viewBox="0 0 34.016 34.016" style={buildIconStyle('18px')} />,
  main: <SectionPrincipal viewBox="0 0 34.016 34.016" style={buildIconStyle('18px')} />,
  finished: <FinishedOrders viewBox="0 0 34.016 34.016" style={buildIconStyle('16px')} />,
  sent: <SectionEnviadas viewBox="0 0 34.016 34.016" style={buildIconStyle('18px')} />,
  archived: <SectionArquivadas viewBox="0 0 24 24" style={buildIconStyle('18px')} />,
  independent: <SectionIndependentes viewBox="0 0 34.016 34.016" style={buildIconStyle('18px')} />,
  rejected: <SectionRecusadas style={buildIconStyle('16px', '18px')} />,
  canceled: <SectionCanceladas viewBox="0 0 34.016 34.016" style={buildIconStyle('18px')} />,
  inspections: <MenuVistorias viewBox="0 0 50 49.998" style={buildIconStyle('34px', '8px')} />,
  clients: <MenuClientes viewBox="0 0 50 49.998" style={buildIconStyle('34px', '8px')} />,
  divergences: <MenuDivergences style={buildIconStyle('34px', '8px')} />,
  dashboard: <MenuDashboard style={buildIconStyle('34px', '8px')} />,
  devices: <MenuDispositivos viewBox="0 0 50 49.998" style={buildIconStyle('34px', '8px')} />,
  actives: <SubMenuAtivos viewBox="0 0 34.016 34.016" style={buildIconStyle('18px', '8px')} />,
  deleted: <SubMenuRemovidos viewBox="0 0 34.016 34.016" style={buildIconStyle('18px', '8px')} />,
  schedule: <CalendarIcon style={buildIconStyle('34px', '8px')} />,
  settings: <SettingsIcon style={buildIconStyle('34px', '8px')} />,
  inspectors: (
    <span
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '34px',
        height: '34px',
        marginRight: '0.5em',
        border: '1px solid #5578a0',
        borderRadius: '50%',
        lineHeight: 0,
      }}
    >
      <InspectorsIcon style={{ fontSize: '16px', width: '16px', height: '16px' }} />
    </span>
  ),
  extract: (
    <span
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '34px',
        height: '34px',
        marginRight: '0.5em',
        border: '1px solid #5578a0',
        borderRadius: '50%',
        lineHeight: 0,
      }}
    >
      <img style={{ height: 'auto', width: '18px' }} src={Extract} alt="Extract" />
    </span>
  ),
};

function MenuIcon({ menuKey }) {
  if (menuKey in menuIcons) {
    return menuIcons[menuKey];
  }

  return <TypeNone viewBox="0 0 34.016 34.016" style={buildIconStyle('18px')} />;
}

MenuIcon.propTypes = {
  /**
   * String with the menu key
   */
  menuKey: PropTypes.string.isRequired,
};

export default MenuIcon;
